import { isMemberStatusPending, parseUtcIso } from './marketingApi';

/** Auto-open panel for external customer_created if outcome within this window. */
export const CREATE_CUSTOMER_AUTO_OPEN_MS = 15 * 60 * 1000;

export function memberListKey(member) {
  if (member?.id != null) return `id:${member.id}`;
  const phone = member?.phone_e164 || member?.phone;
  if (phone) return `ph:${phone}`;
  return '';
}

function isCustomerCreatedPending(member, options = {}) {
  const key = memberListKey(member);
  const oc = String(member?.outcome || '').toLowerCase();
  if (oc !== 'customer_created' || !key) return false;
  if (options.panelOpenKey === key) return true;
  if (options.holdCustomerCreatedKeys?.has?.(key)) return true;
  return false;
}

/** True → show in Pending section (Call Manager): no status recorded yet. */
export function isMemberPendingDisplay(member, _graceUntilByKey = {}, options = {}) {
  if (isCustomerCreatedPending(member, options)) return true;
  return isMemberStatusPending(member?.outcome);
}

/** External create-customer — open panel once when outcome flips to customer_created. */
export function shouldAutoOpenCustomerCreated(member, prevOutcome, options = {}) {
  const oc = String(member?.outcome || '').toLowerCase();
  if (oc !== 'customer_created') return false;
  const key = memberListKey(member);
  if (!key || options.autoOpenedKeys?.has?.(key)) return false;
  const prev = String(prevOutcome || '').toLowerCase();
  if (prev === 'customer_created') return false;
  if (prev) return true;
  const at = parseUtcIso(member?.outcome_at);
  if (!at) return false;
  return Date.now() - at.getTime() <= CREATE_CUSTOMER_AUTO_OPEN_MS;
}
